const pointConfig = {
    pointHistory: {
        filterLayout: 'PointFilterHistoryLayout',
        listLayout: 'PointListHistoryLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getPoint',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            // obt: 'created_at',
            // obs: 'desc',
            post: 'all',
        //    post : plus //밍글 가감 증가-plus, 감소-minus, 전체 -all
        // stg[0] : auction //상태 auction-경매, deal-거래, contest-공모전, mingle-충전/출금, etc-기타
        // crsd : 2021-10-01 //일자 시작
        // cred : 2021-10-01 //일자 종료
        },
    },
    pointAllHistory: {
        filterLayout: 'PointFilterHistoryAllLayout',
        listLayout: 'PointListAllHistoryLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getPoint',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            post: 'all',
        },
    },
    charge: {
        filterLayout: 'PointFilterDefaultLayout',
        listLayout: 'PointListDefaultLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getPoint',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            obt: 'created_at',
            obs: 'desc',
            post: 'all',
            stg : ['charge']
        },
    },
    withdraw: {
        filterLayout: 'PointFilterDefaultLayout',
        listLayout: 'PointListWithdrawLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationWithdrawLayout',
        getFunc: 'getPointWithdraw',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
        },
    },
    product:{
        filterLayout: 'PointFilterNoneLayout',
        listLayout: 'PointListProductLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getProduct',
        listApiParamSet: {
            ip:1,
            sp:10,

        },
        deleteKeyName:'ibp_idx',
        deleteFunc: 'deleteProduct',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {
        },
        deleteErrorTypes: {},
    },
    createProduct:{
        writeLayouts: ['PointWriteDefaultLayout'],
        getFunc: 'getProduct',
        detailApiParamsSet:{},
        writeFunc: 'createProduct',
        directType:'modal',
        directUrl: 'product-write-modal',
        writeApiParamSet: {
            i_type:'point',
        },
        writeSuccessType: 1,
        parsingData: {
            point: 'ibp_point',
            bonus: 'ibp_point_extra',
            price: 'i_price',
            title: 'i_name'
        },
        keyName:''
    },
    updateProduct:{
        writeLayouts: ['PointWriteDefaultLayout'],
        getFunc: 'getProduct',
        detailApiParamsSet:{},
        writeFunc: 'updateProduct',
        directType:'modal',
        directUrl: 'product-write-modal',
        writeApiParamSet: {
            i_type:'point',
        },
        writeSuccessType: 1,
        parsingData: {
            point: 'ibp_point',
            bonus: 'ibp_point_extra',
            price: 'i_price',
            title: 'i_name'
        },
        keyName:'id'
    },
    service:{
        writeLayouts: ['PointWriteServiceLayout'],
        getFunc: 'getService',
        detailApiParamsSet:{
            co:'DETECT',
        },
        writeFunc: 'updateService',
        directType:'',
        directUrl: '',
        writeApiParamSet: {
            pd_code:'DETECT',
        },
        writeSuccessType: 1,
        parsingData: {
            point: 'pd_point',
        },
        keyName:'',
        getFirst:true
    },
    deposit: {
        filterLayout: 'PointFilterDepositLayout',
        listLayout: 'PointListDepositLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getDeposit',
        listApiParamSet: {
            ip: 1,
            obt: 'd_apply',
            obs: 'desc',
        },
    },
    chargeList: {
        filterLayout: 'PointFilterDepositLayout',
        listLayout: 'PointListChargeLayout',
        emptyLayout: 'PointEmptyDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getOrder',
        listApiParamSet: {
            ip:1,
            obt: 'created_at',
            obs: 'desc',
        },
    },

}
export default {
    methods: {
        returnPointConfig(type) {
            return pointConfig[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        // stg: {
        //     type: 'terms',
        //     classname: 'filterStatus',
        //     option: {
        //         [0]: 'auction',
        //         [1]: 'deal',
        //         [2]: 'competition',
        //         [3]: 'mingle',
        //         [4]: 'etc',
        //         [5]: 'charge',
        //     },
        // },
        stg: {
            type: 'match',
            classname: 'filterPointStatus'
        },
        co: {
            type: 'match',
            classname: 'filterPointStatus'
        },
        post: {
            type: 'terms',
            classname: 'mingleArr',
            option: {
                'plus': 'plus',
                'minus': 'minus',
            }
        },
        mid: {
            type: 'query',
            classname: 'searchInput'
        },
        uid: {
            type: 'query',
            classname: 'searchInput'
        },
        ap: {
            type: 'between',
            classname: 'filterApplyDate'
        },
        mbid: {
            type: 'query',
            classname: 'searchInput'
        },
        ni: {
            type: 'query',
            classname: 'searchInput'
        },
        de: {
            type: 'query',
            classname: 'searchInput'
        },
        st: {
            type: 'match',
            classname: "filterDepositStatus"
        },
    },
}
